export default "__VITE_ASSET__5d1d5f52__"